// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var Info = React.forwardRef(function Info(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Info" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12ZM13.8375 8.0625C13.8375 9.07732 13.0148 9.9 12 9.9C10.9852 9.9 10.1625 9.07732 10.1625 8.0625C10.1625 7.04768 10.9852 6.225 12 6.225C13.0148 6.225 13.8375 7.04768 13.8375 8.0625ZM13.5 18V11.25H10.5V18H13.5Z", fill: "currentColor" }))));
});
Info.displayName = 'Info';
export default Info;
